// extracted by mini-css-extract-plugin
module.exports = {"button":"bb_dL","button__primary":"bb_dM","button__red":"bb_dN","button__secondary":"bb_dP","button__secondary__white":"bb_dQ","button__tertiary":"bb_dR"};